<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.277 8.20107C10.7752 7.74039 10 8.12228 10 8.83015L10 15.1698C10 15.8777 10.7752 16.2596 11.277 15.7989L14.7299 12.6291C15.09 12.2984 15.09 11.7016 14.7299 11.3709L11.277 8.20107Z"
    fill="#C2C6CD"
  />
</template>
